/**
 * Life4Earth V2 — Task Consultations API Adapter
 *
 * Records a Consulted (RACI "C") party's response on a task. Governance
 * receipt, not a comment. Phase 1: free-text response only.
 *
 * Endpoint: /api/projects/{guid}/task-consultations
 *
 * Epic: DEV-712 (Role Digest), Task: DEV-737
 */

import { apiFetch } from "./client";

// ── Types ─────────────────────────────────────────────────────

export interface TaskConsultationResponse {
  id: string;
  ganttTaskId: string;
  consultedUserGuid: string;
  roleSlotGuid: string;
  responseText: string;
  respondedAt: string;
}

export interface CreateTaskConsultationRequest {
  ganttTaskId: string;
  roleSlotGuid: string;
  /** Required — empty strings are rejected server-side. */
  responseText: string;
}

// ── API Functions ─────────────────────────────────────────────

/**
 * Fetch consultation responses for a project. Optionally filtered by user.
 */
export async function fetchTaskConsultations(
  projectGuid: string,
  userGuid?: string,
): Promise<TaskConsultationResponse[]> {
  const q = userGuid ? `?userGuid=${encodeURIComponent(userGuid)}` : "";
  return apiFetch<TaskConsultationResponse[]>(
    `/api/projects/${projectGuid}/task-consultations${q}`,
  );
}

/**
 * Create a consultation response. Returns the created record.
 */
export async function createTaskConsultation(
  projectGuid: string,
  req: CreateTaskConsultationRequest,
): Promise<TaskConsultationResponse> {
  return apiFetch<TaskConsultationResponse>(
    `/api/projects/${projectGuid}/task-consultations`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(req),
    },
  );
}
